import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  breadcrumbsSource: BehaviorSubject<{ label: string, url: string }[]> = new BehaviorSubject<{ label: string, url: string }[]>([]);
  breadcrumbs$ = this.breadcrumbsSource.asObservable();
  pageTitleSource: BehaviorSubject<string> = new BehaviorSubject<string>('');
  pageTitle$ = this.pageTitleSource.asObservable();

  addBreadcrumb(newBreadcrumb: { label: string, url: string }[]): void {
    // Replace the current breadcrumbs with the new array of breadcrumb objects
    this.breadcrumbsSource.next(newBreadcrumb);
    console.warn(this.breadcrumbsSource)
  } 
  resetBreadcrumbs() {
    this.breadcrumbsSource.next([]);
  }
  // Method to update the page title
  updatePageTitle(newTitle: string): void {
    this.pageTitleSource.next(newTitle);
  }

  // Method to reset page title
  resetPageTitle(): void {
    this.pageTitleSource.next('');
  }
}
